import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function ItemsNotFound({
  descriptionText = 'The current items list is empty.',
  buttonText,
  buttonAction,
}: {
  descriptionText?: string;
  buttonText?: string;
  buttonAction?: () => void;
}): React.JSX.Element {
  return (
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100%',
        py: '64px',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={6}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              alt="Not found"
              component="img"
              src="/assets/not-found.svg"
              sx={{ height: 'auto', maxWidth: '100%', width: '120px' }}
            />
          </Box>
          <Stack spacing={1} sx={{ textAlign: 'center' }}>
            <Typography variant="h5">No items found.</Typography>
            <Typography color="text.secondary">{descriptionText}</Typography>
          </Stack>
          {buttonText && buttonAction ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" onClick={buttonAction}>
                {buttonText}
              </Button>
            </Box>
          ) : null}
        </Stack>
      </Container>
    </Box>
  );
}
